import { CbhIcon } from "@clipboard-health/ui-components";
import { Box } from "@mui/material";

interface BadgePenaltyCounterProps {
  isFilled: boolean;
  isError?: boolean;
}

export function BadgePenaltyCounter(props: BadgePenaltyCounterProps) {
  const { isFilled, isError = false } = props;

  return (
    <Box
      sx={(theme) => {
        const baseStyles = {
          width: 48,
          height: 48,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        };

        if (isFilled) {
          return {
            ...baseStyles,
            backgroundColor: theme.palette.shift?.badgeSkippedWarning.warningColor,
          };
        }

        if (isError) {
          return {
            ...baseStyles,
            border: `${theme.borderWidth?.thick} dashed ${theme.palette.shift?.badgeSkippedWarning.warningColor}`,
            backgroundColor: "transparent",
          };
        }

        return {
          ...baseStyles,
          border: `${theme.borderWidth?.thick} solid ${theme.palette.border?.primary}`,
          backgroundColor: "transparent",
        };
      }}
    >
      <CbhIcon
        type="badge"
        size="medium"
        sx={(theme) => {
          if (isFilled) {
            return { color: theme.palette.primary.contrastText };
          }

          if (isError) {
            return { color: theme.palette.shift?.badgeSkippedWarning.warningColor };
          }

          return { color: theme.palette.action.disabled };
        }}
      />
    </Box>
  );
}
